import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { DrawerProps } from 'shared/mui/Drawer/Drawer';
import { CloseIconButton } from 'shared/mui/IconButtons';

import { CardHeaderStyled, CardStyled, FilterDrawerStyled } from './FilterDrawer.styled';

export type FilterDrawerProps = DrawerProps;

export const FilterDrawer: React.FC<FilterDrawerProps> = ({
  anchor = 'right',
  children,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <FilterDrawerStyled
      ModalProps={{
        keepMounted: true,
      }}
      anchor={anchor}
      disablePortal={true}
      {...restProps}
    >
      <CardStyled>
        <CardHeaderStyled
          appendActions={[
            <CloseIconButton
              key="close-button"
              onClose={() => {
                if (restProps.onClose) {
                  restProps.onClose({}, 'backdropClick');
                }
              }}
            />,
          ]}
          title={translate('app.filter.filter')}
        />
        {children}
      </CardStyled>
    </FilterDrawerStyled>
  );
};
